import { render, staticRenderFns } from "./ExerciseLoginPage.vue?vue&type=template&id=40cff571&lang=pug"
import script from "./ExerciseLoginPage.vue?vue&type=script&lang=js"
export * from "./ExerciseLoginPage.vue?vue&type=script&lang=js"
import style0 from "./ExerciseLoginPage.vue?vue&type=style&index=0&id=40cff571&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports